// import utils from '@/utils/utils.js';
import varint from 'varint';
import analytics from "@/utils/analytics.js";

var ws = window["itsiWebsockets"];

const websockets = {
    config: {
        analytics: {
            url: ("wss://" + window.location.hostname + "/redstone/api/event").replace("reader.app.dev.it.si", "app.dev.it.si"),
            // combineMessages: true
        }
    },
    getConfigKeyFrom(url) {
        return _.find(Object.keys(websockets.config), function(configKey) {
            return websockets.config[configKey].url === url;
        });
    },
    setupWebsocket: function(handle, configKey) {
        const url = websockets.config[configKey].url;
        // first time init
        if(!ws) {
            ws = {};
        }

        if(!ws[configKey]) {
            ws[configKey] = {
                websocket: undefined,
                status: "Connecting",
                messageQueue: [],
                nextMessageId: 1
            };
        }
        
        // if the websocket exists, close it and clear it
        if(ws[configKey].websocket) {
            ws[configKey].websocket.close();
            ws[configKey].websocket = undefined;
        }
            
        // create the websocket
        const websocket = new WebSocket(url);

        websocket.onopen = function(evt) {
            websockets.updateStatus(configKey, "Connected");
            ws[configKey].websocket = websocket;
        };

        websocket.onclose = function() {
            websockets.updateStatus(configKey, "Closed");
            ws[configKey] = undefined;
            // lastWill: function(handle, username, deviceId)
            analytics.lastWill(handle, handle.$store.state.user.username, handle.$store.state.uniqueId);
            setTimeout(function() {
                websockets.setupWebsocket(handle, configKey)
            }, 10000);
        };

        websocket.onmessage = function(evt) {
            const message = evt.data;
            // console.log("websocket message:", message)
            const url = evt.srcElement.url;
            const configKey = websockets.getConfigKeyFrom(url);
            // console.log(configKey, "Websocket message received: ", message);

            if(message.length >= 3) {
                if(message.substr(0,2) === "OK") {
                    const messageId = message.substr(2);
                    websockets.removeMessageFromQueue(configKey, parseInt(messageId));
                }
            }
        };

        websocket.onerror = function(e) { 
            console.error("Websocket error: ", e);
            ws[configKey] = undefined;
            // lastWill: function(handle, username, deviceId)
            analytics.lastWill(handle, handle.$store.state.user.username, handle.$store.state.uniqueId);
        };

        setInterval(websockets.checkToSendMessages, 10000);
    },
    checkToSendMessages() {
        // check all websocket connections
        Object.keys(ws).forEach(function(configKey) { 
            // if it is initialised

            // message id as varint, data length as varint, proto data
            if(ws[configKey] && ws[configKey].messageQueue) {
                // if(websockets.config[configKey].combineMessages) {
                //     var highestMsgId = 0;

                //     var byteArrays = _.map(ws[configKey].messageQueue, function(message) {
                //         highestMsgId = Math.max(message.msgId, highestMsgId);
                //         return message.data;
                //     });

                //     ws[configKey].websocket.send(websockets.getMessagePackaged(highestMsgId, websockets.combineMessages(byteArrays)));
                // } else {
                ws[configKey].messageQueue.forEach(function(message) {
                    // message id as varint, then data
                    ws[configKey].websocket.send(websockets.getMessagePackaged(message.msgId, message.data));
                });
                // }
            }
        });
    },
    // message id as varint, data length as varint, proto data
    getMessagePackaged(msgId, data) {
        // console.log("msgId:", msgId);
        return websockets.combineMessages([varint.encode(msgId), varint.encode(data.length), data]);
    },
    removeMessageFromQueue(configKey, msgId) {
        _.remove(ws[configKey].messageQueue, {
            msgId: msgId
        });
    },
    send(configKey, data) {
        // If the websocket connection exists, push it to the queue. It should exist.
        if(ws[configKey]) {
            ws[configKey].messageQueue.push({msgId: ws[configKey].nextMessageId++, data});

            // reset index if it is too big
            if(ws[configKey].nextMessageId >= Number.MAX_SAFE_INTEGER) {
                ws[configKey].nextMessageId = 1;
            }
        }
    },
    updateStatus(configKey, status) {
        ws[configKey].status = status;
        // console.log(configKey, "Websocket status changed: ", ws[configKey].status);
    },
    combineMessages(byteArrays) { 
        const totalLength = _.reduce(byteArrays, function(sum, arr) {
            return sum + arr.length;
        }, 0);

        var uint8Array = new Uint8Array(totalLength);
        var index = 0;

        byteArrays.forEach(function(arr) {
            for(var i = 0; i < arr.length; i++) {
                uint8Array[index++] = arr[i];
            }
        })

        // console.log("ByteArrays", byteArrays);
        // console.log("Combined", uint8Array);

        return uint8Array;
    }
}

export default websockets;